import React, { useState } from 'react';
import { Button } from '@components/ui/button';
import { Card } from '@components/ui/card';

const EXPERIENCE_LEVELS = [
  {
    id: 'complete-beginner',
    title: "I'm completely new to it",
    description: 'Starting from scratch with little to no prior knowledge (pre-high school level)',
  },
  {
    id: 'basic-understanding',
    title: 'I have some basic understanding',
    description: 'Familiar with fundamentals but need to build deeper knowledge (high school level)',
  },
  {
    id: 'some-experience',
    title: 'I have some experience/knowledge',
    description: 'Looking to expand on existing skills and fill knowledge gaps (university/college level)',
  },
  {
    id: 'refresher',
    title: "I'm looking for a refresher",
    description: 'Already knowledgeable but want to reinforce or gain new insights (graduate/professional level)',
  },
];

const ExperienceLevelStep = ({ onNext, onBack, formData, canGoBack }) => {
  const [selectedLevel, setSelectedLevel] = useState(formData.experienceLevel || '');

  const handleContinue = () => {
    onNext({ experienceLevel: selectedLevel });
  };

  return (
    <div className="space-y-8 animate-fade-in">
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold text-foreground">What level are you at?</h1>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Help us understand your current knowledge level with{' '}
          <span className="font-semibold text-primary">{formData.learningGoal || 'Web Development'}</span>.
        </p>
      </div>

      <div className="space-y-4">
        <p className="text-sm font-medium text-foreground">Select your current level</p>

        <div className="space-y-4">
          {EXPERIENCE_LEVELS.map((level) => (
            <Card
              key={level.id}
              className={`p-6 cursor-pointer transition-all hover:bg-secondary/80 ${
                selectedLevel === level.id ? 'bg-primary/10 border-primary' : 'bg-secondary border-border'
              }`}
              onClick={() => setSelectedLevel(level.id)}>
              <div className="flex items-start space-x-4">
                <div
                  className={`w-5 h-5 rounded-full border-2 mt-0.5 flex-shrink-0 ${
                    selectedLevel === level.id ? 'bg-primary border-primary' : 'border-border'
                  }`}>
                  {selectedLevel === level.id && <div className="w-full h-full rounded-full bg-primary" />}
                </div>
                <div className="space-y-2">
                  <h3 className="font-semibold text-foreground">{level.title}</h3>
                  <p className="text-sm text-muted-foreground">{level.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>

      <div className="flex justify-between pt-8">
        {canGoBack && (
          <Button variant="outline" onClick={onBack} className="px-8">
            Back
          </Button>
        )}
        <Button onClick={handleContinue} disabled={!selectedLevel} className="px-8 ml-auto">
          Continue
        </Button>
      </div>
    </div>
  );
};

export default ExperienceLevelStep;
